module.exports = "/_next/static/media/af45f2a5f0d2e9a16c7280050acb3423.svg";